var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"pbr-empty"},[_vm._t("image"),(_vm.description)?[_c('p',[_vm._v(" "+_vm._s(_vm.description)+"} ")])]:[_c('p',[_vm._v(" "+_vm._s(_vm.$t('noData'))+" ")])]],2)
}
var staticRenderFns = []

export { render, staticRenderFns }